export default class ContactCount {
	constructor({ "total-count": totalCount }) {
		this._total = totalCount;
	}

	getTotal() {
		return this._total;
	}
}